"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notify = void 0;
const Noty = require("noty");
const DOM_1 = require("./DOM");
const ReportFeedbackControl_1 = require("../../../app/controls/General/ReportFeedbackControl/ReportFeedbackControl");
const Modal_1 = require("./Modal");
const Toggles_1 = require("./Toggles");
Noty.overrideDefaults({
    callbacks: {
        afterShow: function () {
            const button = DOM_1.DOM.Parser.getHtmlElement(this.id).querySelector('button');
            if (button === null) {
                return;
            }
            DOM_1.DOM.Parser.getHtmlElementByClass('btn', DOM_1.DOM.Parser.getHtmlElement(this.id))
                .addEventListener('click', () => {
                const eventId = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('event', button);
                ReportFeedbackControl_1.ControlsGeneralReportFeedbackControl.Control.doShowModal(true, eventId);
            });
        },
        onTemplate: function () {
            const trsElem = DOM_1.DOM.Parser.getHtmlElement('jsTranslations');
            const codeTrs = DOM_1.DOM.Parser.getDataByNameFromElement('trsNotifyCode', trsElem);
            const eventTrs = DOM_1.DOM.Parser.getDataByNameFromElement('trsNotifyEvent', trsElem);
            const reportTrs = DOM_1.DOM.Parser.getDataByNameFromElement('trsNotifyReport', trsElem);
            const suffix = this.options.message.type.charAt(0).toUpperCase() + this.options.message.type.slice(1);
            const title = trsElem ? trsElem.dataset['trsNotify' + suffix] : null;
            const eventElem = this.options.message.eventId ?
                `<div class="noty-body-event">
                    ${eventTrs}: ${this.options.message.eventId}
                </div>` : '';
            const codeElem = this.options.message.uniqKeys && this.options.message.uniqKeys.length > 0 ?
                `<div class="noty-body-code">
                    ${codeTrs}: ${this.options.message.uniqKeys.join('_')}
                </div>` : '';
            const messageElem = this.options.message.message !== null ?
                `<div class="noty-body-text">
                    ${this.options.message.message}
                </div>` : '';
            const reportElemDisabled = !Toggles_1.Toggles.Handler.toggleAvailable('SENTRY');
            const reportElem = this.options.message.type === 'error' ?
                `<div class="noty-body-report">
                    <button ${reportElemDisabled ? 'disabled' : ''} class="btn btn-blue btn-minimal" data-event="${this.options.message.eventId ?? ''}">${reportTrs}</button>
                </div>` : '';
            this.barDom.innerHTML = `
                <div class="noty ${this.options.message.type}">
                    <div class="noty-body">
                        <div class="noty-body-title">
                            <div class="noty-body-title-icon">
                                <img src="/resources/images/2023/notify/${this.options.message.type}.svg" alt="${this.options.message.type}" />
                            </div>
                            <div class="noty-body-title-text">${title}</div>
                        </div>
                        ${messageElem}
                        ${codeElem}
                        ${eventElem}
                        ${reportElem}
                    </div>
                    <div class="noty_progressbar" style="transition: width 10000ms linear 0s; width: 100%;"></div>
                </div>
            `;
        }
    }
});
var Notify;
(function (Notify) {
    class Handler {
        static processMessagesFromDOM() {
            const domElem = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('notify', DOM_1.DOM.Parser.getHtmlElementByQuery('body'));
            if (!domElem || domElem.trim().length === 0) {
                return;
            }
            const notifyMessages = JSON.parse(domElem);
            this.processMessages(notifyMessages);
        }
        static processMessages(messageItems, muteSuccess = false, modalCloseByNotify = false) {
            let container = undefined;
            const shownModal = Modal_1.Modal.Helpers.getShownModal();
            if (shownModal !== null && !modalCloseByNotify) {
                const errorElem = DOM_1.DOM.Parser.getHtmlElementByClass('customDesign-modals-content-error', shownModal);
                container = '.' + DOM_1.DOM.Parser.getDataByNameFromElement('selector', errorElem);
            }
            Noty.setMaxVisible(3, 'global');
            Noty.setMaxVisible(1, 'modal');
            for (let i = 0; i < messageItems.length; i++) {
                const message = messageItems[i];
                if (message.type === "success" && muteSuccess) {
                    return;
                }
                new Noty({
                    message: message,
                    layout: "bottomRight",
                    progressBar: true,
                    timeout: message.type === "success" ? 6000 : 12000,
                    queue: container ? 'modal' : 'global',
                    animation: {
                        open: container ? null : 'noty_effects_open',
                        close: container ? null : 'noty_effects_close'
                    },
                    container: container
                }).show();
            }
        }
        static isErrorByNotify(messageItems) {
            for (let i = 0; i < messageItems.length; i++) {
                if (messageItems[i].type === "error") {
                    return true;
                }
            }
            return false;
        }
        static isModalCloseByNotify(messageItems) {
            for (let i = 0; i < messageItems.length; i++) {
                if (messageItems[i].closeModal) {
                    return true;
                }
            }
            return false;
        }
        static showServerError(eventId, uniqKeys) {
            this.processMessages([{
                    message: document.getElementById('jsTranslations')?.dataset['trsNotifyFatalError'] ?? null,
                    type: "error",
                    closeModal: null,
                    uniqKeys: uniqKeys ? uniqKeys : null,
                    eventId: eventId
                }]);
        }
        static getMessageFromPayload(payload) {
            let response;
            if (payload.response)
                response = JSON.parse(payload.response);
            else
                response = payload;
            if (!response.flashMessages)
                return null;
            return response.flashMessages[0] ?? null;
        }
    }
    Notify.Handler = Handler;
})(Notify || (exports.Notify = Notify = {}));
